<template>
  <div class="warning-container">
    <img src="@/assets/alert.svg" alt="" />
    <div class="warning-container-content">
      <span>{{ $t('dialogs.useAtYourOwnRisk') }}</span>
      <span>
        {{ $t('dialogs.unverifiedTokenCaution') }}
      </span>
      <PButton
        class="p-button-primary w-full relative flex footer-button justify-content-center border-round-3xl mt-3"
        @click="onClose"
      >
        {{ $t('common.continue') }}
      </PButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';

const dialogRef = inject('dialogRef');

defineEmits(['close']);

function onClose() {
  dialogRef.value.close();
}
</script>
<style lang="scss" scoped>
.warning-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 2rem;
  img {
    width: 64px;
    height: 64px;
    margin-bottom: 2rem;
  }
  &-content {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
    align-items: center;

    & > span:first-child {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 0.1px;
    }

    & > span:nth-child(2) {
      display: flex;
      align-items: center;
      text-align: center;
      font-size: 15px;
      line-height: 24px;
      font-weight: 400;
      color: #e5e4fa;
      width: 90%;
    }
  }
}
</style>
